import { lazy } from 'react'

import NewspaperIcon from '@heroicons/react/outline/esm/NewspaperIcon.js'

import { PostListOrderByEnum } from '@tribeplatform/gql-client/types'
import { FeedProps } from '@tribeplatform/react-components/Feed'
import { I18nShape } from '@tribeplatform/react-components/i18n'

import { BlockType, RegisteredBlock } from '../../types/index.js'
import { FeedBlock as Component } from './Block.js'

const Settings = lazy(() =>
  import('./Settings.js').then(m => ({ default: m.FeedBlockSettings })),
)

export const RegisteredFeedBlock = (
  intl: I18nShape,
): RegisteredBlock<FeedProps> => {
  const { $t } = intl

  return {
    recommendedName: 'Feed',
    Component,
    config: {
      type: BlockType.Block,
      usable: true,

      displayName: $t({ id: 'Generics.Feed', defaultMessage: 'Feed' }),
      Settings,
      Icon: <NewspaperIcon />,
      defaultProps: {
        view: 'card',
        orderBy: PostListOrderByEnum.publishedAt,
      },
    },
  }
}
